if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.inputInstallation = document.querySelector('#instalations-services');
        this.form.querySelector('[name=id]').disabled = false;
        this.id = this.form.querySelector('[name=id]').value;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        for (const input of this.form) {
          if (input.id === 'instalations-services') {
            input.addEventListener("change", () => {
              if (window.innerWidth >= 768) {
                this.form.querySelector('#propertiesInstalation').value = input.checked ? 'true' : 'false';
              }
              else {
                document.querySelector('#propertiesInstalation').value = input.checked ? 'true' : 'false';
              }
              this.onChange(input)
            })
          }
        }


      }
      getSectionsToRender() {
        return [

          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'cart-icon-bubble-mobile',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
        ];
      }
      getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
      }

      onSubmitHandler(evt) {

        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.inputInstallation !== null && this.inputInstallation.dataset.variant !== undefined && this.inputInstallation.dataset.variant !== "" && this.inputInstallation.checked === true) {
          formData.append('properties[_installation_product_id]', this.inputInstallation.dataset.variant);
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        fetch(`${routes.cart_url}.js`)
          .then(response => response.json())
          .then(cart => {
            function isMobileDevice() {
              const mobileDevices = [
                'Android', 'webOS', 'iPhone', 'iPad', 'iPod', 'BlackBerry', 'Windows Phone', 'IEMobile', 'Opera Mini'
              ];
              return mobileDevices.some(device => navigator.userAgent.includes(device)) ||
                (window.innerWidth <= 800 && window.innerHeight <= 600);
            }
            let productId;
            let quantity;
            let urlParams = new URLSearchParams(window.location.search);
            let variantIdFromUrl = urlParams.get('variant');

            if (isMobileDevice()) {
              productId = variantIdFromUrl ? variantIdFromUrl : evt.submitter.getAttribute('data-variant-id');
              const qtyInput = document.querySelector(".product-form__input-qty");
              quantity = qtyInput ? qtyInput.value : 1;

              // Asegurarse de que el productId sea válido
              if (!productId) {
                const variantInput = evt.target.querySelector('input[name="id"]');
                productId = variantInput ? variantInput.value : null;
              }

              // Si aún no tenemos un ID válido, intentar obtenerlo del botón
              if (!productId) {
                productId = evt.submitter.closest('product-form').querySelector('input[name="id"]').value;
              }
            } else {
              productId = formData.get('id')
              quantity = formData.get("quantity");
            }
            const lineItem = cart.items.find(item => Number(item.id) === Number(productId));

            let url = `${routes.cart_add_url}`;
            let id = productId;

            if (!id) {
              console.error('No se pudo obtener un ID de producto válido');
              this.handleErrorMessage('Error al agregar el producto al carrito');
              return;
            }

            if (lineItem) {

              quantity = lineItem.quantity + Number(quantity);
              url = `${routes.cart_change_url}`;
              id = lineItem.key;
            }

            formData.append('id', id);
            formData.append('quantity', quantity);


            config.body = formData;

            return fetch(url, config);
          })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');

            if (this.inputInstallation !== null && this.inputInstallation.dataset.variant !== undefined && this.inputInstallation.dataset.variant !== "" && this.inputInstallation.checked === true) {

              this.addServicesProduct(this.inputInstallation.dataset.variant, this.id);
            }
            else {
              this.cart.renderContents(response);
              this.getSectionsToRender().forEach((section) => {
                const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  response.sections[section.section],
                  section.selector
                );


              });
            }
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    this.getSectionsToRender().forEach((section) => {
                      const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

                      elementToReplace.innerHTML = this.getSectionInnerHTML(
                        response.sections[section.section],
                        section.selector
                      );


                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      onChange(input) {
        if ((input.dataset.variant === window.themeVariables.productGrillInstalation || input.dataset.variant === window.themeVariables.productInstalation) && input.checked) {
          this.openServicesModal(input)

        } else if ((input.dataset.variant === window.themeVariables.productGrillInstalation || input.dataset.variant === input.dataset.variant === window.themeVariables.productInstalation) && input.checked === false) {
          this.removeServicesProduct(input.dataset.variant)
        }
      }

      openServicesModal(input) {
        const variantId = input.dataset.variant
        const servicesModals = document.querySelectorAll(".services-modal")

        servicesModals.forEach(servicesModal => {
          const addButton = servicesModal.querySelector(".modal-button")
          const closeButton = servicesModal.querySelector("span.services-modal__close.desktop");
          const closeButton_mob = servicesModal.querySelector(".services-modal__header.mobile span.services-modal__close");

          servicesModal.classList.add("show")

          addButton.addEventListener("click", () => {
            servicesModal.classList.remove("show")
          }) <

            closeButton.addEventListener("click", () => {
              servicesModal.classList.remove("show")
              input.checked = false
            })
          closeButton_mob.addEventListener("click", () => {
            servicesModal.classList.remove("show")
            input.checked = false
          })
        });



      }

      addServicesProduct(variantId, productId) {

        const data = {
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                'parent_product_instalation_id': productId
              }
            }
          ],
          sections: [
            'cart-icon-bubble',
            'cart-drawer',
            'cart-icon-bubble'
          ],
        };


        fetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((response) => {

            this.cart.renderContents(response);
          })

          .catch((e) => {
            console.error(e);
          });
      }
      removeServicesProduct(variantId) {

        const data = {
          updates: {
            [variantId]: 0
          },
          sections: "main-cart-footer"
        };


        fetch(`${routes.cart_update_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((response) => {


          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}